import { Component, OnInit } from '@angular/core'
import { FeedListItem } from '../../../../../models/feed-list-item.model'
import { FeedMetadataService } from '../../../../services/feed-metadata.service'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { RouterModule } from '@angular/router'
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-feed-list',
  standalone: true,
  templateUrl: './feed-list.component.html',
  styleUrls: ['./feed-list.component.scss'],
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatChipsModule
  ]
})
export class FeedListComponent implements OnInit {

  loading = false
  rows: FeedListItem[] = []
  displayedColumns = ['product', 'destination', 'excluded', 'overrides', 'actions']

  constructor(private feedMetadataService: FeedMetadataService) { }

  ngOnInit(): void {
    this.load()
  }

  load(): void {
    this.loading = true
    this.feedMetadataService.getFeedList()
      .then(data => {
        this.rows = data
        this.loading = false
      })
      .catch(() => this.loading = false)
  }
}
